const showHideFilters = {
    filterWrap: document.querySelectorAll(
      '.jsFilterWrap',
    ) as NodeListOf<HTMLElement>,
  
    init() {
      this.toggleFilters();
    },
  
    toggleFilters() {
      this.filterWrap.forEach((filter: HTMLElement) => {
        const singleFilters: NodeListOf<HTMLElement> =
          filter.querySelectorAll('.jsFilter');
        const btns: HTMLElement | null = filter.querySelector('.jsShowMore');
  
        if (singleFilters.length > 8 && btns) {
          filter.classList.add('filter-less');
          if (btns.style) {
            btns.style.display = 'block';
          }
        } else if (btns && btns.style) {
          btns.style.display = 'none';
        }
  
        if (btns) {
          btns.addEventListener('click', () => {
            filter.classList.toggle('filter-less');
            filter.style.height = filter.classList.contains('filter-less')
              ? 'auto'
              : 'auto'
  
            if (btns.textContent) {
              btns.textContent = filter.classList.contains('filter-less')
                ? 'View all +'
                : 'View all -'
            }
          });
        }
      });
    },
  };
  
  export default showHideFilters;
  